<template>
    <modal-wrapper modalClass="modal--small" :modalName="name">
        <div class="modal__header">
            <h3>{{ $t('cookies.cookies') }}</h3>
        </div>
        <div class="modal__content">
            {{ $t('cookies.description') }}
        </div>
        <div class="modal__footer">
            <button class="button--cta" type="submit" @click="confirm">{{ $t('cookies.confirm') }}</button>
            <button class="button--link">{{$t('cookies.more_information')}}</button>
        </div>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import ModalWrapper from '@/components/general/ModalWrapper';

    @Component({
        components: {
            ModalWrapper
        }
    })
    export default class CookieModal extends Vue {
        name = 'cookie-modal';

        confirm() {
            this.$emit('confirm');
            this.$modal.hide(this.name);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/cookies/CookieModal.vue